// Tiny analytics helper — fire-and-forget POST to /api/quote-analytics/event.
// Never blocks the UI; silently drops on network failure.
const API_URL = process.env.REACT_APP_BACKEND_URL;

// Stable per-page-session id so we can de-dupe rapid duplicate events
let _sessionId = null;
const sessionId = () => {
  if (_sessionId) return _sessionId;
  _sessionId = `qs-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  return _sessionId;
};

export const trackQuoteEvent = (event_type, extras = {}) => {
  try {
    const body = JSON.stringify({
      event_type,
      session_id: sessionId(),
      source: typeof window !== 'undefined' ? window.location.pathname : null,
      ...extras,
    });
    // Use sendBeacon when available (survives page unload, no CORS preflight)
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(`${API_URL}/api/quote-analytics/event`, blob);
      return;
    }
    fetch(`${API_URL}/api/quote-analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (_) { /* swallow */ }
};
